export let DocumentTypeFormat = /*#__PURE__*/function (DocumentTypeFormat) {
  DocumentTypeFormat["SINGLE"] = "SINGLE";
  DocumentTypeFormat["FRONT_BACK"] = "FRONT_BACK";
  return DocumentTypeFormat;
}({});